<template>
  <section>
    <h6>Please input your test values below and save</h6>
    <b-row>
        <b-col>
          <div class="d-flex justify-content-start align-items-end mb-2">
            <b-form-group label="Quantity" class="mr-2 required">
              <b-form-input type="number" v-model="formData.quantity" size="sm"
                            :class="{ 'is-invalid': $v.formData.quantity.$error }"/>
            </b-form-group>
            <b-form-group label="Item" class="mr-2 required">
              <lookup-dropdown label="Service Item" :lookupId="44" resource="ServiceItems" :value="formData.serviceItemTypeId" :options="serviceItems"
                :isInvalid="$v.formData.serviceItemTypeId.$error" @change="onItemTypeChange"  />
            </b-form-group>
            <b-form-group label="Cost" class="mr-2 required">
              <b-form-input type="number" v-model="formData.cost" size="sm"
                            :class="{ 'is-invalid': $v.formData.cost.$error }"/>
            </b-form-group>
            <b-form-group label="Status" class="mr-2">
              <b-form-select v-model="formData.statusId">
                <option v-for="status in statuses" :key="status.id" :value="status.id">{{ status.name }}</option>
              </b-form-select>
            </b-form-group>
            <b-form-group label="Comments" class="mr-2">
              <b-form-input v-model="formData.comments" size="lg"/>
            </b-form-group>
            <b-button class="mr-2 btn btn-primary" size="sm" @click="onSubmit" :disabled="isSaving" variant="primary"
            v-if="checkClaim(CAN_ADD_WORK_ORDER) || checkClaim(CAN_EDIT_WORK_ORDER)"><i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save</b-button>
            <b-button size="sm" @click="resetModal">Reset</b-button>
          </div>

          <!-- <h6 class="mt-2">Click row to edit.</h6> -->
          <grid-component
            isResizable
            isReorderable
            :canEdit="checkClaim(CAN_EDIT_WORK_ORDER)"
            :canDelete="checkClaim(CAN_DELETE_WORK_ORDERS)"
            :gridId="gridId"
            :itemData="itemData"
            :fields="fields"
            :onDelete="onDelete"
            :handleRowClick="onEdit"
            @getData="onGetData"
          />
        </b-col>
    </b-row>
  </section>
  <!-- <div class="animated fadeIn ServiceOrderLineItems--ServiceOrderLineItems-list">
    <b-modal size="xl" :id="modalId" @hidden="onHiddenModal" @show="resetModal">
      <template slot="modal-header">
        <h5 class="modal-title">Add/Edit Item</h5>
      </template>
    </b-modal>
  </div> -->
</template>

<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

  import { GRID_ID } from '@/shared/constants';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import gridFields from './fields';
  import { required } from 'vuelidate/lib/validators';

  const SEARCH_DEBOUNCE_TIME = 750;

  export default {
    components: {
      GridSettings,
      GridComponent,
    },
    props: {
      serviceOrderId: {
        type: [Number, String],
        default: 0,
      }
    },
    metaInfo: () => ({
      title: 'ServiceOrderLineItems',
    }),
    data() {
      return {
        fields: gridFields,
        gridId: GRID_ID.SERVICEORDER_LINEITEMS,
        pageable: {
          pageSizes: 0,
        },
        selectedRowItemId: 0,
        formData: {
          id: 0,
          serviceItemTypeId: '',
          quantity: '',
          cost: '',
          statusId: 1487,
          comments: '',
        },
        lookupItemOptions: {},
        initialQuantity: '',
        isSaving: false,
        isLoading: false,
        statuses: [
          {id: 1487, name: 'In Progress'},
          {id: 1485, name: 'Passed'},
          {id: 1486, name: 'Failed'},
        ]
      };
    },
    validations: {
      formData: {
        serviceItemTypeId: { required },
        quantity: { required },
        cost: { required },
      },
    },
    computed: {
      ...mapGetters('serviceOrderLines', ['serviceOrderLine']),
      ...mapGetters('lookup', ['serviceItems']),
      // ...mapState('serviceOrderLineItems', ['lastOpenedId']),
      ...mapGetters('serviceOrderLineItems', [
        'serviceOrderLineItemsList',
        'serviceOrderLineItem',
        'pageInfo',
        'searchQuery',
        'selectedItemId',
        'lastOpenedId',
        'lineItemsByLineId'
      ]),
      ...mapGetters('account', ['gridSettingsById']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      itemData() {
        if (this.serviceOrderLineItemsList == undefined || this.serviceOrderLineItemsList.length === 0) return [];
        return this.serviceOrderLineItemsList.map((ServiceOrderLineItem) => ({
          ...ServiceOrderLineItem,
          //selected: ServiceOrderLineItem.id === this.selectedRowItemId,
        }));
      },
    },
    methods: {
      // ...mapMutations('serviceOrderLineItems', [
      //   'setLastOpenedId',
      //   'setIds',
      //   'setServiceOrderLineItemsList',
      // ]),
      ...mapMutations('serviceOrderLineItems', ['setItem']),
      ...mapActions('serviceOrderLines', ['getServiceOrderLine', 'updateServiceOrderLine','getByServiceOrderId', 'getLinesWithItems']),
      ...mapActions('lookup', ['getLookupValueById']),
      ...mapActions('serviceOrderLineItems', ['getAll', 'manage', 'deleteRecord']),
      ...mapActions('account', ['saveGridSettings']),
      onItemTypeChange($event) {
        this.formData.serviceItemTypeId = $event.value || $event.id || null;
      },
      async resetModal() {
        this.formData = {};
        this.$v.$reset();
        this.$v.formData.$reset();
      },
      onEdit({ dataItem }) {
        this.formData = {
          id: dataItem.id,
          serviceItemTypeId: dataItem.serviceItemTypeId || '',
          quantity: dataItem.quantity,
          cost: dataItem.cost || '',
          statusId: dataItem.statusId || 1487,
          comments: dataItem.comments || '',
        };
      },
      async refreshData() {
        this.getAll({
          serviceOrderId: this.serviceOrderId,
          serviceOrderLineId: this.serviceOrderLine.id
        });
        if (this.serviceOrderId) {
          this.getByServiceOrderId(this.serviceOrderId);
          this.$emit('onRefresh');
        }
      },
      async onSubmit(evt) {
        this.$v.formData.$touch();
        if (this.$v.formData.$invalid) {
          return;
        } else {
          try {
            this.formData.total = this.formData.cost * this.formData.quantity;
            this.formData.serviceOrderId = this.serviceOrderId;
            this.formData.serviceOrderLineId = this.serviceOrderLine.id;
            this.formData.active = true;
            this.isSaving = true;
            const result = await this.manage(this.formData);
            this.isSaving = false;
            if (result) {
              this.resetModal();
              this.refreshData();
            }
          }catch (e) {
            this.isSaving = false;
            /*console.log(e.message);*/
          }
        }
      },
      async onGetData(params) {
        await this.getAll(params);
      },
      async onDelete(row) {
        const deleteConfirmed = await this.openConfirmBox({});
        if (deleteConfirmed) {
          await this.deleteRecord(row.id);
          //Get the data
          this.refreshData();
        }
      },
      async updateQuantity() {
        if (this.serviceOrderLine.quantity == '') {
          return;
        } else {
          try {
            this.isLoading = true;
            const result = await this.updateServiceOrderLine({
              ...this.serviceOrderLine,
              quantity: this.serviceOrderLine.quantity
            });
            this.isLoading = false;
            if (result) {
              this.initialQuantity = result.quantity;
              this.getByServiceOrderId(result.serviceOrderId);
            }
          } catch (e) {
            this.isSaving = false;
            /*console.log(e.message);*/
          }
        }
      },
      async onLoadServiceOrderLine() {
        if (this.serviceOrderLine.id && this.serviceOrderId) {
          console.log('trigger',this.serviceOrderLine.id)
          // this.getByServiceOrderId(this.serviceOrderId);
          // this.setIds({ 'serviceOrderId': this.serviceOrderId, 'serviceOrderLineId': this.serviceOrderLine.id });
          this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort} });
          this.setItem({ resource: 'serviceOrderId', payload: this.serviceOrderId });
          this.setItem({ resource: 'serviceOrderLineId', payload: this.serviceOrderLine.id });
          await this.getAll({});
        }
      }
    }
  };
</script>
